<template>
    <div class="userconfig" v-loading="loading">
        <div class="selectleft">
            <div class="newroles">新建角色</div>
            <el-input placeholder="请输入角色名称"
                      v-model="rolesvalue"
                      @focus="roleFocus"
                      size="small"
                      clearable>
            </el-input>
            <div class="newroles">角色名称</div>
            <template v-for="(item,index) in rolesall" :key="item.id">
                <p @click="chooseColor(index)" :class="['rolename',index == nowindex?'active':'']">{{item.name}}<span @click.stop="deleteList(index)" :class="[index == nowindex?'showdel':'','delete']">删除</span></p>
            </template>
        </div>
        <div class="selectright" :style="{height:rightHeight+'px'}">
            <div class="newrolestwo">配置角色权限</div>
            <div v-for="(selectMenu,selectMenuId) in alllist" :key="selectMenuId">
                <p class="titlep">
                    <el-checkbox :indeterminate="selectMenu.isIndeterminate" v-model="selectMenu.selected" class="selectAll"
                                 @change="allCheckboxGroup($event, selectMenu, selectMenu.list)">
                        {{selectMenu.name}}
                    </el-checkbox>
                </p>
                <el-checkbox v-model="menuChild.selected" v-for="(menuChild,menuChildId) in selectMenu.list" :key="menuChildId"
                             @change="checkOneBox(selectMenu, selectMenu.list)">
                    {{menuChild.name}}
                </el-checkbox>
            </div>
            <el-button v-if="savecun" class="savedata" @click="savedata" size="small" type="primary">{{nowindex==99999?'保存':'修改'}}</el-button>
        </div>
    </div>
</template>
<script>
    import { permissions, rolesall, newaddRoles, deleteRole, editRole } from "@/api/user.js";
    export default {
        data() {
            return {
                loading: false,
                rolesvalue: '',
                value: '',
                checkAll: false,
                checkedpermiss: [],
                dictions: [],
                isIndeterminate: true,
                rightHeight: document.documentElement.clientHeight - 120,
                alllist: [],
                rolesall: [],
                nowindex: '',
                rolesid: '',
                rolesname: '',
                savecun: true,
                judge: 'dev,support,管理员,科室,单位,部门'
            }
        },
        methods: {
            //左侧的栏目切换事件
            chooseColor(index) {
                this.nowindex = index
                this.rolesid = this.rolesall[index].id
                this.rolesname = this.rolesall[index].name
                let contain = this.rolesall[index].permissions.toString()//角色的权限
                this.emptylist()
                if (this.judge.indexOf(this.rolesname) > -1) {
                    this.savecun = false
                } else {
                    this.savecun = true
                }
                //判断权限列表里是否包含当前角色的权限，如果有就选中
                for (let i = 0; i < this.alllist.length; i++) {
                    for (let j = 0; j < this.alllist[i].list.length; j++) {
                        if (contain.indexOf(this.alllist[i].list[j].id) > -1) {
                            this.alllist[i].list[j].selected = true
                        }
                    }
                }
            },
            //删除事件
            deleteList(index) {
                let that = this
                this.rolesid = this.rolesall[index].id
                this.rolesname = this.rolesall[index].name
                if (this.judge.indexOf(this.rolesname) > -1) {
                    this.$message.error("此角色暂时不允许删除");
                    return false
                }
                let data = { id: this.rolesall[index].id }
                this.$confirm('您确定删除这条数据吗？').then(() => {
                    deleteRole(data).then(res => {
                        this.$message.success("删除成功!");
                        that.nowindex = 99999
                        that.emptylist()
                        that.roles()
                    })
                }).catch(() => {
                    console.log('取消删除')
                })
            },
            // 是否全选
            allCheckboxGroup(e, preList, sonList) {
                if (e) { //这里的e就是一级菜单的selected
                    if (sonList) {
                        for (let i = 0; i < sonList.length; i++) {
                            sonList[i].selected = true;
                        }
                        preList.isIndeterminate = false;
                    }
                } else {
                    if (sonList) {
                        for (let i = 0; i < sonList.length; i++) {
                            sonList[i].selected = false;
                        }
                    }
                }
            },
            //单个选择
            checkOneBox(preList, sonList) {
                //tickCount选了的总量，unTickCount没选数量 这里的 e就是当前复选框的selected值
                var tickCount = 0, unTickCount = 0, len = sonList.length
                for (let i = 0; i < len; i++) {
                    if (sonList[i].selected == true) tickCount++;
                    if (sonList[i].selected == false) unTickCount++;
                }
                if (tickCount == len) { //选中数量=子级总数，全选
                    preList.selected = true;
                    preList.isIndeterminate = false;
                } else if (unTickCount == len) { //未选中数量=子级总数，未全选
                    preList.selected = false;
                    preList.isIndeterminate = false;
                } else { //其他情况是不确定状态
                    preList.selected = false;
                    preList.isIndeterminate = true;
                }
            },
            //获取角色列表
            roles() {
                rolesall().then(res => {
                    this.rolesall = res.roles
                })
            },
            handleCheckAllChange(val) {
                this.checkedpermiss = val ? this.dictions : [];
                this.isIndeterminate = false;
            },
            //新增角色
            savedata() {
                //角色权限id
                let passdata = []
                let editdata = []
                for (let i = 0; i < this.alllist.length; i++) {
                    for (let j = 0; j < this.alllist[i].list.length; j++) {
                        if (this.alllist[i].list[j].selected == true) {
                            passdata.push(this.alllist[i].list[j].id)
                            editdata.push({ id: this.alllist[i].list[j].id, access: 1 })
                        }
                    }
                }
                if (this.nowindex != 99999) {
                    let rolesid = this.rolesall[this.nowindex].id
                    let rolesname = this.rolesall[this.nowindex].name
                    let toedit = {
                        id: rolesid,
                        name: rolesname,
                        description: '',
                        permissions: editdata
                    }
                    this.editScope(toedit)
                } else {
                    if (this.rolesvalue == '') {
                        this.$message.error("文件名不能为空");
                        return
                    }
                    let data = {
                        name: this.rolesvalue,
                        permissions: passdata
                    }
                    this.saveScope(data)
                }
            },
            async saveScope(data) {
                //console.log('新增', data)
                let res = await newaddRoles(data)
                if (res.status == 0) {
                this.$message.success('新增角色成功');
                }
                this.roles()
                this.emptylist()
            },
            //修改权限
            async editScope(data) {
                let res = await editRole(data)
                if (res.status == 0) {
                    this.$message.success('修改权限成功');
                }
            },
            //清空数据列表
            emptylist() {
                //清空列表
                for (let i = 0; i < this.alllist.length; i++) {
                    this.alllist[i].selected = false;
                    this.alllist[i].isIndeterminate = false;
                    for (let j = 0; j < this.alllist[i].list.length; j++) {
                        this.alllist[i].list[j].selected = false
                    }
                }
                this.rolesvalue = ''
            },
            //输入框聚焦时清空数据
            roleFocus() {
                //如果左侧栏目是选中状态，点击输入框清空列表
                if (this.rolesvalue == '' && this.nowindex != 99999) {
                    this.emptylist()
                }
                this.savecun = true
                this.nowindex = 99999
            },
            //获取权限列表
            permissions() {
                this.loading = true
                //let list = new Object()
                //list.name = [{}]
                let list = [{ name: '添加及导出', list: [] }, { name: '编辑', list: [] }, { name: '审批及查看', list: [] }, { name: '删除', list: [] }, { name: '其它', list: [] }]
                list.forEach(function (item, index) {
                    item.selected = false
                    item.isIndeterminate = false
                })
                //分组
                permissions().then(res => {
                    this.dictions = res.permissions
                    res.permissions.forEach(function (item, index) {
                        item.selected = false
                        if (item.name.indexOf('加') > -1 || item.name.indexOf('导') > -1) {
                            list[0].list.push(item)
                        } else if (item.name.indexOf('修改') > -1 || item.name.indexOf('编辑') > -1 || item.name.indexOf('配置') > -1) {
                            list[1].list.push(item)
                        } else if (item.name.indexOf('审') > -1 || item.name.indexOf('查看') > -1) {
                            list[2].list.push(item)
                        } else if (item.name.indexOf('删除') > -1 || item.name.indexOf('重置') > -1 || item.name.indexOf('清空') > -1) {
                            list[3].list.push(item)
                        } else {
                            list[4].list.push(item)
                        }
                    })
                    this.alllist = list
                    this.loading = false
                })
            },
            //复选框的值改变
            handleCheckedCitiesChange(value) {
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.dictions.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.dictions.length;
            }
        },
        mounted() {
            this.nowindex = 99999
            this.roles()
            this.permissions()
        }
    }
</script>
<style scoped>
    .titlep .el-checkbox /deep/ .el-checkbox__label {
        box-sizing: border-box;
        font-size: 18px !important;
        padding: 20px 0 10px 10px;
        font-family: fangsong;
        color: #606266;
    }

    .rolename {
        font-size: 18px;
        color: #606266;
        box-sizing: border-box;
        padding-left: 20px;
        /*font-family: fangsong;*/
        line-height: 43px;
        cursor: pointer;
        border-radius: 5px;
    }

    .delete {
        display: none;
        float: right;
        margin-right: 10px;
        font-size: 13px;
        color: #f56c6c;
    }

    .showdel {
        display: block !important;
    }

    .rolename:hover .delete {
        display: block;
        transition: ease 0.3s;
    }

    .rolename:hover {
        background-color: #ecf5ff;
    }

    .active {
        background-color: #ecf5ff;
    }

    .userconfig {
        width: 100%;
        padding: 20px 50px;
    }

    .selectleft {
        width: 20%;
        height: auto;
        float: left;
    }

    .selectright {
        width: 80%;
        float: right;
        box-sizing: border-box;
        padding: 5px 20px;
        overflow-y: scroll;
    }

    /deep/ .selectright .el-checkbox {
        width: 50% !important;
        margin-right: 0;
        font-size: 19px;
    }

    .newroles {
        color: #606266;
        font-size: 20px;
        font-family: fangsong;
        margin: 8px 0px;
        margin-left: 20px;
    }

    .newrolestwo {
        color: #606266;
        font-size: 20px;
        font-family: fangsong;
        margin: 8px 0px;
    }

    .savedata {
        margin-top: 20px;
    }
</style>